import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=af92aaa2&scoped=true&"
import script from "./ShippingMethod.vue?vue&type=script&lang=js&"
export * from "./ShippingMethod.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethod.vue?vue&type=style&index=0&id=af92aaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af92aaa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextarea})
